module.exports = ".full-width {\r\n    width: 100% !important;\r\n}"